import axios from 'axios';
import { applyEnvelopeInterceptor } from '@workpay/ds-shared/services/envelopeInterceptor';
import { API_BASE } from './runtimeConfig';

/**
 * Unauthenticated HTTP client for the localization-service.
 *
 * Separate from `publicClient` (which is hardcoded to /api/contract-service).
 * Targets the localization-service public-bundle endpoint set live on 2026-05-26.
 * No auth headers — the gateway's MatchAndStripPublic bypasses auth for the two
 * GET endpoints (`/v1/strings/bundle`, `/v1/languages`); other endpoints on the
 * same prefix would 401.
 *
 * `baseURL` is cross-origin to `api.<apex>` in deployed envs (derived at runtime
 * from `window.location.hostname` — see `runtimeConfig.ts`). Empty in local
 * dev so Vite's proxy or the local docker stack handles it same-origin. Without
 * this, deployed `external.<apex>` would call its own origin for the bundle —
 * which doesn't serve `/api/localization-service` — instead of `api.<apex>`.
 */
export const localizationClient = axios.create({
  baseURL: `${API_BASE}/api/localization-service`,
  headers: { 'Content-Type': 'application/json' },
});

applyEnvelopeInterceptor(localizationClient);
